import { useCallback } from 'react';

import { useGlobalHotKey } from 'containers/GlobalHotKeys';
import { useSelector } from 'react-redux';
import { getThemeKey } from 'themes/themesSelectors';
import useSetThemeKey from 'hooks/useSetThemeKey';
import useThemeMode from 'hooks/useThemeMode';

const AppearanceHotKeys = () => {
  const themeKey = useSelector(getThemeKey);
  const setThemeKey = useSetThemeKey();
  const themeMode = useThemeMode();

  const onToggleAppearanceMode = useCallback(() => {
    setThemeKey(
      themeKey === 'system-appearance'
        ? themeMode === 'dark'
          ? 'muiDefault'
          : 'ACME_DARK'
        : themeKey === 'ACME_DARK'
          ? 'muiDefault'
          : 'ACME_DARK',
    );
  }, [setThemeKey, themeKey, themeMode]);
  useGlobalHotKey({
    description: 'Toggle Light/Dark Mode Appearance',
    shiftKey: true,
    altKey: true,
    code: 'KeyA',
    callback: onToggleAppearanceMode,
  });

  return null;
};
export default AppearanceHotKeys;
